// Constants extracted from UnitPlanModule.js

import React from "react";
import {
  NODE_TYPE_IB_DP_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM,
  NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
  NODE_TYPE_UBD_CURRICULUM_PROGRAM,
} from "Constants/stringConstants";
import {
  UploadCloudOutlined,
  CancelledCloudOutlined,
  DownloadCloudOutlined,
} from "@toddle-edu/ds-icons";

// Constants
export const NAME = "unitPlans";
export const UPDATE_FILTER_OBJECT = "UPDATE_FILTER_OBJECT" + " " + NAME;
export const UPDATE_LEARNING_COURSE_FILTER_OBJECT =
  "UPDATE_LEARNING_COURSE_FILTER_OBJECT" + " " + NAME;
export const INIT_FILTER_OBJECT = "INIT_FILTER_OBJECT" + " " + NAME;
export const SET_CURRENT_TAB = "SET_CURRENT_TAB" + " " + NAME;
export const SET_CURRENT_UNIT_PLAN_TITLE =
  "SET_CURRENT_UNIT_PLAN_TITLE" + " " + NAME;
export const UPDATE_LOCAL_RESOURCE = "UPDATE_LOCAL_RESOURCE" + " " + NAME;
export const INIT_LOCAL_RESOURCE = "INIT_LOCAL_RESOURCE" + " " + NAME;
export const SET_UNIT_PLAN_MODE = "SET_UNIT_PLAN_MODE" + " " + NAME;
export const SET_DIRECT_CREATE_UNIT_PLAN_MODE =
  "SET_DIRECT_CREATE_UNIT_PLAN_MODE" + " " + NAME;
export const SET_UNIT_PLAN_READ_ONLY = "SET_UNIT_PLAN_READ_ONLY" + " " + NAME;
export const SWITCH_YEARLY_VIEW = "SWITCH_YEARLY_VIEW" + " " + NAME;
export const SET_UNIT_PLAN_EVIDENCE_VIEW =
  "SET_UNIT_PLAN_EVIDENCE_VIEW" + " " + NAME;
export const SET_UNIT_PLAN_COUNT = "SET_UNIT_PLAN_COUNT" + " " + NAME;
export const SET_CURRENT_VIEW_TYPE = "SET_CURRENT_VIEW_TYPE" + " " + NAME;
export const RESET_CURRENT_VIEW_TYPE = "RESET_CURRENT_VIEW_TYPE" + " " + NAME;
export const SET_COLLAPSABLE_DESC = "SET_COLLAPSABLE_DESC" + " " + NAME;
export const SET_ACTIVE_UNIT_PLAN_ID = "SET_ACTIVE_UNIT_PLAN_ID" + " " + NAME;
export const SET_ACTIVE_OWNER_UNIT_PLAN_ID =
  "SET_ACTIVE_OWNER_UNIT_PLAN_ID" + " " + NAME;
export const SET_CUSTOM_RIGHT_PANE = "SET_CUSTOM_RIGHT_PANE" + " " + NAME;
export const SET_SHOW_LEFT_PANE = "SET_SHOW_LEFT_PANE" + " " + NAME;
export const TOGGLE_TODDLEPLAY = "TOGGLE_TODDLEPLAY" + " " + NAME;
export const TOGGLE_UNITPLAN_VIEW = "TOGGLE_UNITPLAN_VIEW" + " " + NAME;

export const UPDATE_DISPLAY_SETTINGS = "UPDATE_DISPLAY_SETTINGS" + " " + NAME;
export const SET_PROMPTS_VISIBILITY = "SET_PROMPTS_VISIBILITY" + " " + NAME;
export const UPDATE_IMPORT_UNIT_FILTER_OBJECT =
  "UPDATE_IMPORT_UNIT_FILTER_OBJECT" + " " + NAME;
export const INIT_IMPORT_UNIT_FILTER_OBJECT =
  "INIT_IMPORT_UNIT_FILTER_OBJECT" + " " + NAME;
export const SET_SELECTED_IMPORT_UNIT_PLAN =
  "SET_SELECTED_IMPORT_UNIT_PLAN" + " " + NAME;
export const SET_BULK_IMPORT_UNIT_PLANS =
  "SET_BULK_IMPORT_UNIT_PLANS" + " " + NAME;
export const UPDATE_COMBINED_LIBRARY_FILTER =
  "UPDATE_COMBINED_LIBRARY_FILTER" + " " + NAME;
export const UPDATE_INCLUDE_REFLECTIONS_OPTION =
  "UPDATE_INCLUDE_REFLECTIONS_OPTION" + " " + NAME;

export const UPDATE_TODDLE_LIBRARY_FILTER =
  "UPDATE_TODDLE_LIBRARY_FILTER " + NAME;
export const UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER =
  "UPDATE_TODDLE_LIBRARY_UNIT_FEED_FILTER " + NAME;
export const UPDATE_PLANNER_ELEMENT_SETS =
  "UPDATE_PLANNER_ELEMENT_SETS " + NAME;
export const UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS =
  "UPDATE_TODDLE_LIBRARY_UNIT_PLAN_DETAILS " + NAME;
export const RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS =
  "RESET_TODDLE_LIBRARY_UNIT_PLAN_DETAILS " + NAME;
export const UPDATE_TODDLE_LIBRARY_COURSE_INFO =
  "UPDATE_TODDLE_LIBRARY_COURSE_INFO " + NAME;
export const SET_SCROLL_FIELD = "SET_SCROLL_FIELD" + " " + NAME;
export const SET_UNIT_AI_CONTEXT = "SET_AI_CONTEXT" + " " + NAME;

export const UPDATE_COURSE_FILTER_SEARCH_TEXT = `UPDATE_COURSE_FILTER_SEARCH_TEXT ${NAME}`;
export const UPDATE_CLASS_FILTER_SEARCH_TEXT = `UPDATE_CLASS_FILTER_SEARCH_TEXT ${NAME}`;

export const FIELD_UID_CURRICULUM_MAPPING = {
  IB_PYP: ["theme", "subjects"],
  IB_MYP: ["globalContextMYP", "subjects", "objectiveLevel", "hours"],
  UBD: ["subjects"],
  IB_DP: [
    "subjectStandardDP",
    "aimDP",
    "syllabusContentDP",
    "objectivesDP",
    "hours",
    "subjectLevel",
  ],
};
export const CURRICULUM_NODE_ENTITY_TYPE_MAPPING = {
  CURRICULUM_TYPE_DP: NODE_TYPE_IB_DP_CURRICULUM_PROGRAM,
  CURRICULUM_TYPE_MYP: NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM,
  CURRICULUM_TYPE_PYP: NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM,
  CURRICULUM_TYPE_UBD: NODE_TYPE_UBD_CURRICULUM_PROGRAM,
};
export const DEFAULT_TODDLE_LIBRARY_UNIT_PARAMS = {
  title: "",
  dateDuration: null,
  selectedTemplate: null,
  subjects: [],
  mypObjectiveLevels: [],
  subjectGroups: [],
  unitHours: null,
};
export const UNIT_STATUS_MAP = {
  PUBLISHED: {
    localeLabel: "common:published",
    icon: <UploadCloudOutlined size={"xxx-small"} variant={"on"} />,
  },
  NOT_PUBLISHED: {
    localeLabel: "common:not_published",
    icon: <CancelledCloudOutlined size={"xxx-small"} variant={"on"} />,
  },
  UNPUBLISHED_CHANGES: {
    localeLabel: "common:unpublished_changes",
    icon: <CancelledCloudOutlined size={"xxx-small"} variant={"on"} />,
  },
  IMPORTED: {
    localeLabel: "toastMsgs:imported",
    icon: <DownloadCloudOutlined size={"xxx-small"} variant={"on"} />,
  },
};

export const FLOW = "flow";
export const CARD = "card";
export const TABLE = "table";
export const TIMELINE = "timeline";
export const CARD_VIEW = "cardView";
export const TIMELINE_VIEW = "timelineView";
export const COURSE_OVERVIEW = "courseOverview";

export const validRoutes = [
  FLOW,
  CARD,
  TABLE,
  TIMELINE,
  CARD_VIEW,
  TIMELINE_VIEW,
  COURSE_OVERVIEW,
];

export const unitPlanDefaultFilters = {
  searchText: "",
  // isShowPrivate: true,
  grades: [],
  subjects: [],
  subjectGroups: [],
  unitType: [],
};

export const defaultOrderConstants = {
  orderBy: "UNIT_TYPE",
  orderByDirection: "ASC",
  first: 24,
};
